const features = [
  {
    icon: 'ri-shield-flash-line',
    title: '安全直达',
    desc: '所有在线吃瓜入口均经过安全检测认证，杜绝钓鱼网站与恶意跳转。直达目标页面，无中间页、无广告劫持，保障每一次访问的安全与纯净。',
  },
  {
    icon: 'ri-refresh-line',
    title: '实时更新',
    desc: '7×24小时不间断监测91在线吃瓜网、线路一及各备用网址的可用状态。入口变更后第一时间更新，确保您获取的永远是最新有效的访问地址。',
  },
  {
    icon: 'ri-stack-line',
    title: '多线保障',
    desc: '提供官方线路及多条备用网址，当主入口不可用时自动推荐其他可用通道。多地CDN加速部署，无论身处国内还是海外都能快速访问在线吃瓜内容。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="flex items-center gap-3 mb-10">
          <span className="w-8 h-8 rounded-lg bg-primary-500/15 flex items-center justify-center flex-shrink-0">
            <i className="ri-star-line text-primary-400"></i>
          </span>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-100">为什么选择我们</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {features.map((f, i) => (
            <div key={i} className="p-6 rounded-xl bg-background-100 border border-background-300/30 hover:border-primary-500/15 transition-colors duration-200 text-center">
              <span className="w-14 h-14 rounded-2xl bg-primary-500/10 flex items-center justify-center mx-auto mb-4">
                <i className={`${f.icon} text-2xl text-primary-400`}></i>
              </span>
              <h3 className="text-sm md:text-base font-semibold text-foreground-200 mb-2">{f.title}</h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}